import React, { useEffect, useState } from "react";
import { NavLink, Outlet, useNavigate } from "react-router-dom";

const linkClass = ({ isActive }) =>
  `rounded-full px-4 py-2 text-sm font-medium transition-colors ${
    isActive ? "bg-[#fbd9e5] text-[#3e2723]" : "text-white/70 hover:bg-white/10 hover:text-white"
  }`;

export default function AdminLayout() {
  const navigate = useNavigate();
  const [ready, setReady] = useState(false);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const r = await fetch("/api/admin/session.php", { credentials: "include" });
        const j = await r.json();
        if (cancelled) return;
        if (!j.ok) {
          navigate("/admin/login", { replace: true });
          return;
        }
        setReady(true);
      } catch {
        if (!cancelled) navigate("/admin/login", { replace: true });
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [navigate]);

  const onLogout = async () => {
    await fetch("/api/admin/logout.php", { method: "POST", credentials: "include" }).catch(() => {});
    navigate("/admin/login", { replace: true });
  };

  if (!ready) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#1a1514] text-[#f5f0ee] text-sm">
        Se verifică accesul…
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#1a1514] text-[#f5f0ee]">
      <header className="sticky top-0 z-10 border-b border-white/10 bg-[#1a1514]/95 backdrop-blur-sm px-4 py-3">
        <div className="mx-auto flex max-w-6xl flex-wrap items-center justify-between gap-3">
          <span className="text-sm font-semibold tracking-tight">Admin Social Destiny</span>
          <nav className="flex flex-wrap items-center gap-2">
            <NavLink to="/admin" end className={linkClass}>
              Personalizare
            </NavLink>
            <NavLink to="/admin/json" className={linkClass}>
              JSON expert
            </NavLink>
            <button
              type="button"
              onClick={onLogout}
              className="rounded-full border border-white/20 px-4 py-2 text-sm text-white/80 hover:bg-white/5"
            >
              Ieșire
            </button>
          </nav>
        </div>
      </header>
      <main className="px-4 py-6">
        <Outlet />
      </main>
    </div>
  );
}
